<template>
  <div :style="{ display: 'inline-block' }" v-bind="filteredAttrs">
    <div
      :class="[
        bem.e('cropper-avatar'),
        props.disabled ? bem.is('disabled') : '',
      ]"
      :style="{
        cursor: props.disabled ? 'not-allowed' : 'pointer',
        display: 'inline-flex',
        borderRadius: borderRadius,
        border: `1px var(--color-border) ${borderType}`,
      }"
      @click="handleOpen"
      @mouseenter="mouseenter"
      @mouseleave="mouseleave"
    >
      <a-spin :spinning="loading" style="display: inline-block">
        <slot :src="avatar">
          <template v-if="avatar">
            <ll-image
              v-bind="getImgBindValue"
              :src="avatar"
              :width="avatarSize"
              :height="avatarSize"
              :is-show-border="false"
              :border-radius="borderRadius"
              :preview="{ visible: false }"
            >
              <template #previewMaskContent>
                <div
                  v-if="maskMode === 'default'"
                  :class="bem.m('preview-mask-default')"
                >
                  <ll-icon
                    :icon-name="`icon-pwd-look`"
                    :class="bem.e('image-icon')"
                    @click.stop="imageVisible = true"
                  />

                  <ll-icon
                    :icon-name="`icon-delete`"
                    :class="bem.e('image-icon')"
                    @click.stop="handleRemoveImage"
                  />
                </div>
                <!-- 渐入式 -->
                <div
                  v-else
                  :class="bem.m('preview-mask-fade-in')"
                  :style="{ height: isHover ? maskHeight : '0' }"
                >
                  <div
                    :class="bem.m('mask-text')"
                    :style="{ fontSize: maskTextSize }"
                  >
                    {{ maskText }}
                  </div>
                </div>
              </template>
            </ll-image>
          </template>
          <template v-else>
            <div
              :class="bem.e('cropper-upload')"
              :style="{ width: sizeStyle, height: sizeStyle }"
            >
              <ll-icon
                :icon-name="uploadIcon || 'icon-add'"
                :size="uploadIconSize"
              />

              <!-- 上传标题 -->
              <div v-if="uploadTitle" :class="bem.m('upload-title')">
                {{ uploadTitle }}
              </div>
              <!-- 上传提示 -->
              <div v-if="uploadTip" :class="bem.m('upload-tip')">
                {{ uploadTip }}
              </div>
            </div>
          </template>
        </slot>
      </a-spin>
      <div style="display: none">
        <a-image-preview-group
          :preview="{
            visible: imageVisible,
            onVisibleChange: (vis: boolean) => (imageVisible = vis),
          }"
        >
          <a-image :src="avatar" />
        </a-image-preview-group>
      </div>
    </div>
    <ll-new-modal
      :open="open"
      :title="props.title"
      :width="800"
      :keyboard="false"
      :mask-closable="false"
      :ok-text="'确定'"
      :loading="uploadLoading"
      @cancel="handleCancel"
      @ok="handleOk"
    >
      <div :class="bem.b()">
        <div :class="bem.e('left')">
          <div :class="bem.e('cropper')">
            <cropper-image
              v-if="src && open"
              :src="src"
              height="300px"
              :circled="circled"
              :loading="uploadLoading"
              @cropend="handleCropend"
              @on-ready="handleReady"
            />
          </div>
          <div :class="bem.e('toolbar')">
            <ll-space>
              <a-upload
                :file-list="[]"
                accept="image/*"
                :before-upload="handleBeforeUpload"
              >
                <ll-tooltip :title="'选择图片'" placement="bottom">
                  <ll-button
                    type="primary"
                    size="small"
                    :disabled="uploadLoading"
                    @click="handlerToolbar('reset')"
                  >
                    <ll-icon icon-name="icon-upload" />
                  </ll-button>
                </ll-tooltip>
              </a-upload>
              <ll-tooltip :tip="'重置'" placement="bottom">
                <ll-button
                  type="primary"
                  size="small"
                  :disabled="!src || uploadLoading"
                  @click="handlerToolbar('reset')"
                >
                  <ll-icon icon-name="icon-refresh" />
                </ll-button>
              </ll-tooltip>
              <ll-tooltip :tip="'逆时针旋转'" placement="bottom">
                <ll-button
                  type="primary"
                  size="small"
                  :disabled="!src || uploadLoading"
                  @click="handlerToolbar('rotate', -45)"
                >
                  <ll-icon icon-name="icon-counter-clockwise" />
                </ll-button>
              </ll-tooltip>
              <ll-tooltip :tip="'顺时针旋转'" placement="bottom">
                <ll-button
                  type="primary"
                  size="small"
                  :disabled="!src || uploadLoading"
                  @click="handlerToolbar('rotate', 45)"
                >
                  <ll-icon icon-name="icon-clockwise-rotation" />
                </ll-button>
              </ll-tooltip>
              <ll-tooltip :tip="'水平翻转'" placement="bottom">
                <ll-button
                  type="primary"
                  size="small"
                  :disabled="!src || uploadLoading"
                  @click="handlerToolbar('scaleX')"
                >
                  <ll-icon icon-name="icon-flip-horizontal" />
                </ll-button>
              </ll-tooltip>
              <ll-tooltip :tip="'垂直翻转'" placement="bottom">
                <ll-button
                  type="primary"
                  size="small"
                  :disabled="!src || uploadLoading"
                  @click="handlerToolbar('scaleY')"
                >
                  <ll-icon icon-name="icon-flip-vertical" />
                </ll-button>
              </ll-tooltip>
              <ll-tooltip :tip="'放大'" placement="bottom">
                <ll-button
                  type="primary"
                  size="small"
                  :disabled="!src || uploadLoading"
                  @click="handlerToolbar('zoom', 0.1)"
                >
                  <ll-icon icon-name="icon-amplify1" />
                </ll-button>
              </ll-tooltip>
              <ll-tooltip :tip="'缩小'" placement="bottom">
                <ll-button
                  type="primary"
                  size="small"
                  :disabled="!src || uploadLoading"
                  @click="handlerToolbar('zoom', -0.1)"
                >
                  <ll-icon icon-name="icon-scale" />
                </ll-button>
              </ll-tooltip>
            </ll-space>
          </div>
        </div>
        <div :class="bem.e('right')">
          <a-spin :spinning="uploadLoading">
            <div :class="bem.e('preview')">
              <img v-if="previewSource" :src="previewSource" :alt="'预览'" />
            </div>
            <template v-if="previewSource">
              <div :class="bem.e('group')">
                <ll-image
                  :preview="false"
                  :src="previewSource"
                  :width="32"
                  :height="32"
                />
                <ll-image
                  :preview="false"
                  :src="previewSource"
                  :width="48"
                  :height="48"
                />
                <ll-image
                  :preview="false"
                  :src="previewSource"
                  :width="64"
                  :height="64"
                />
                <ll-image
                  :preview="false"
                  :src="previewSource"
                  :width="80"
                  :height="80"
                />
              </div>
            </template>
          </a-spin>
        </div>
      </div>
    </ll-new-modal>
  </div>
</template>
<script lang="ts" setup>
import { createNamespace, dataURLtoBlob, type Nullable } from '@ll-plus/utils'
import { computed, ref, useAttrs, watch, watchEffect } from 'vue'
import {
  cropperModalEmits,
  cropperModalProps,
  type CropendResult,
} from './cropper-image'
import CropperImage from './cropper-image.vue'
//@ts-ignore
import type Cropper from 'cropperjs'
import { imageProps } from '../../image'
import { watermarkProps } from '../../watermark'

defineOptions({ name: 'LlCropperModal' })

const props = defineProps(cropperModalProps)
const emits = defineEmits(cropperModalEmits)
const bem = createNamespace('cropper-modal')

const attrs = useAttrs()

const src = ref<string>(props.avatar || '')
const previewSource = ref<string>('')
const open = ref<boolean>(false)
const loading = ref<boolean>(props.loading)
const uploadLoading = ref<boolean>(false)
const imageVisible = ref<boolean>(false)

const isHover = ref(false)

const cropper = ref<Nullable<Cropper>>()
let scaleX = 1
let scaleY = 1

// 获取图片宽高（适配单位）
const sizeStyle = computed(() => {
  if (typeof props.avatarSize === 'number') {
    return `${props.avatarSize}px`
  } else if (typeof props.avatarSize === 'string') {
    return props.avatarSize
  } else return undefined
})

// 获取绑定给图片组件的属性
const getImgBindValue = computed(() => {
  const imagePropKeys = Object.keys({ ...imageProps, ...watermarkProps })
  return Object.fromEntries(
    Object.entries(attrs).filter(([key]) => imagePropKeys.includes(key)),
  )
})

const filteredAttrs = computed(() => {
  // 获取 watermarkProps 的所有键名
  const watermarkKeys = Object.keys(watermarkProps)

  // 过滤 attrs 对象
  return Object.fromEntries(
    Object.entries(attrs).filter(([key]) => !watermarkKeys.includes(key)),
  )
})

// Block upload
const handleBeforeUpload = (file: File) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  uploadLoading.value = true
  src.value = ''
  previewSource.value = ''
  reader.onload = function (e) {
    src.value = (e.target?.result as string) ?? ''
    uploadLoading.value = false
    // filename = file.name
  }
  reader.onerror = () => {
    uploadLoading.value = false
  }
  return false
}
const handleOpen = () => {
  if (props.disabled) return
  open.value = true
}
const handleCropend = ({ imgBase64 }: CropendResult) => {
  previewSource.value = imgBase64
}

const handleReady = (cropperInstance: Cropper) => {
  cropper.value = cropperInstance
}
const handlerToolbar = (event: string, arg?: number) => {
  if (event === 'scaleX') {
    scaleX = arg = scaleX === -1 ? 1 : -1
  }
  if (event === 'scaleY') {
    scaleY = arg = scaleY === -1 ? 1 : -1
  }
  cropper?.value?.[event]?.(arg)
}

const handleOk = async () => {
  const blob = dataURLtoBlob(previewSource.value)
  emits('confirm', { blob, previewSource: previewSource.value })
  emits('update:avatar', previewSource.value)
  src.value = previewSource.value
  open.value = false
}

const handleCancel = async () => {
  await cleanValue()
  open.value = false
}

const handleRemoveImage = () => {
  src.value = ''
  previewSource.value = ''
  emits('update:avatar', '')
}

const mouseenter = () => {
  isHover.value = true
}
const mouseleave = () => {
  isHover.value = false
}

const cleanValue = () => {
  src.value = ''
  previewSource.value = ''
}

watch(open, (val) => {
  if (val) {
    src.value = props.avatar
    previewSource.value = props.avatar
  }
})

watchEffect(() => {
  loading.value = props.loading
})
defineExpose({
  cleanValue,
})
</script>
